import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import StickyFooter from "./StickyFooter";
import FollowUs from "../Home/FollowUs";
import IMAGES from "../../img/image";
import "../Footer/Footer.css";
import logo512 from "../../img/logo512.png";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  return (
    <React.Fragment>
      <div className="container-fluid footer-container">
        <div className="wa-icon-cont">
          <Link target="_blank" to="https://wa.me/919954967855">
            <img src={IMAGES.whatsapp} alt="WhatsApp" style={{ width: "40px", height: "40px" }} />
          </Link>
        </div>
        
        {/* Reach Us At Section */}
        <FollowUs />
        
        {/* Brand Logo and Tagline */}
        <div className="footer-brand-section">
          <div className="footer-logo">
            <img src={logo512} alt="Logo" width={100}  />
          </div>
          <p className="footer-tagline">
            Top up your game in an instant and get back to what matters—epic wins, fast play, and non-stop action!
          </p>
        </div>

        {/* Links Sections */}
        <div className="row footer-links-row">
          <div className="px-lg-5 quick-links col-6 col-sm-6 col-md-3 col-lg-3 mb-4">
            <h6>Quick Links</h6>
            <hr />
            <ul>
              {user && (
                <li>
                  <Link to="/user-dashboard">Dashboard</Link>
                </li>
              )}
              <li>
                <Link to="/">Home</Link>
              </li>
            </ul>
          </div>
          <div className="quick-links col-6 col-sm-12 col-md-3 col-lg-3 mb-4">
            <h6>Important Links</h6>
            <hr />
            <ul>
              <li>
                <Link to="/terms">Terms and conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Payments Channel Section */}
        <div className="payments-channel-section">
          <h6>Payments Channel</h6>
          <div className="payment-channels">
            <img src={IMAGES.paytm} alt="Paytm" />
            <img src={IMAGES.phonepe} alt="PhonePe" />
            <img src={IMAGES.gpay} alt="Google Pay" />
          </div>
        </div>
      </div>
      <StickyFooter />
    </React.Fragment>
  );
};

export default Footer;
